import {LeadEventApiDto, LeadFilesAttachedEventDataApiDto} from "../../../api/model/rest";
import LeadEvent, {LeadEventTypeEnum} from "./LeadEvent";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import Attachment from "../../attachment/Attachment";
import moment = require("moment");
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {IconColor} from "../../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";

export default class LeadFilesAttachedEvent extends LeadEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {string} leadId lead id.
	 * @param {LeadEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} entity entity which creates the event.
	 * @param {moment.Moment} creationDate creation date of event.
	 * @param {string} referenceNumber lead reference number.
	 * @param data lead files attached files event data
	 */
	constructor(public readonly id: string,
		public readonly leadId: string,
		public readonly type: LeadEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly creationDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly data: LeadFilesAttachedEventData) {
		super(id, leadId, type, entity, creationDate, referenceNumber);
	}

	public static fromJson(json: LeadEventApiDto): LeadFilesAttachedEvent {
		const data = LeadFilesAttachedEventData.fromJson(json.data as LeadFilesAttachedEventDataApiDto);
		const entity = AuthenticatedEntity.fromJson(json.entity);
		return new LeadFilesAttachedEvent(json.id,
			json.leadId,
			LeadEventTypeEnum.LeadFilesAttached,
			entity,
			moment(json.createdAt),
			json.referenceNumber,
			data);
	}

	getIcon() {
		return Icon.File;
	}

	getIconColor(): IconColor {
		return IconColor.Burgundy;
	}

	getAttachments(): Attachment[] {
		return this.data.attachments;
	}

	getActivityMessage(): string {
		return "Files added";
	}
}

export class LeadFilesAttachedEventData {
	constructor(public readonly attachments: Attachment[]) {}

	public static fromJson(json: LeadFilesAttachedEventDataApiDto): LeadFilesAttachedEventData {
		return new LeadFilesAttachedEventData(json.attachments.map(Attachment.fromJson));
	}
}
